<template>
  <div class>
    <div class="jm-white-container">
      <div class="col-lg-10 mx-auto">
        <form>
          <!-- CINEMA HEADER -->
          <section>
            <div class="row">
              <div class="col-md-12">
                <h5
                  class="font-weight-bold"
                >Cinema {{ currentCinemaIndex }} : Screen {{current_screen_index}}/ {{noOfScreens}}</h5>
              </div>
            </div>
          </section>

          <section>
            <div class="row">
              <div class="col-md-6 d-flex mb-4">
                <div class="w-100">
                  <div class="input-container">
                    <input
                      v-model="screen_details.screen_name"
                      type="text"
                      id="sn"
                      name="Screen Name"
                      placeholder="Screen Name*"
                      v-validate="{required: 'required', regex:/^[a-zA-Z0-9- ]*$/}"
                    />
                    <label for="sn">Screen Name*</label>
                  </div>
                  <p v-if="submitted && errors.has('Screen Name')" class="error_message">
                    <!-- {{ item.fieldname }} -->
                    {{ errors.first("Screen Name")}}
                  </p>
                  <!-- <p class="error_msg">Invalid Name</p> -->
                </div>
                <Tooltip :title="`Name of the screen`" :classname="`mt-3`" />
              </div>

              <div class="col-md-6 d-flex w-100 mb-4">
                <div class="w-100">
                  <b-dropdown
                    :text="selectedFormat.label"
                    variant="dropdown-curve-lg bg-theme-light"
                    class="w-100"
                  >
                    <b-dropdown-item
                      v-for="(format, formatKey) in Formats"
                      :key="formatKey"
                      v-on:click="onSelectFormat(format)"
                    >{{format.mf_name}}</b-dropdown-item>
                  </b-dropdown>
                  <p
                    v-if="submitted && selectedFormat.label == 'Select Movie Format'"
                    class="error_message"
                  >Please Select Movie Format.</p>
                </div>
                <Tooltip :title="`Movie format like 2D, 3D etc`" :classname="`mt-3`" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 d-flex">
                <div class="w-100">
                  <div class="input-container">
                    <input
                      v-model="screen_details.no_of_rows"
                      type="text"
                      id="nor"
                      name="No. of Rows"
                      placeholder="No. of Rows"
                      v-validate="'required|numeric'"
                    />
                    <label for="nor">No. of Rows</label>
                  </div>
                  <p v-if="submitted && errors.has('No. of Rows')" class="error_message">
                    <!-- {{ item.fieldname }} -->
                    {{ errors.first("No. of Rows")}}
                  </p>
                  <!-- <p class="error_msg">Invalid Name</p> -->
                </div>
                <Tooltip :title="`No. of rows`" :classname="`mt-3`" />
              </div>

              <div class="col-md-6 d-flex">
                <div class="w-100">
                  <div class="input-container">
                    <input
                      type="text"
                      v-model="screen_details.no_of_cols"
                      id="noc"
                      name="No. of Columns"
                      placeholder="No. of Columns"
                      v-validate="'required|numeric'"
                    />
                    <label for="noc">No. of Columns</label>
                  </div>
                  <p v-if="submitted && errors.has('No. of Columns')" class="error_message">
                    <!-- {{ item.fieldname }} -->
                    {{ errors.first("No. of Columns")}}
                  </p>
                  <!-- <p class="error_msg">Invalid Name</p> -->
                </div>
                
                <Tooltip :title="`No. of columns`" :classname="`mt-3`" />
              </div>
            </div>
          </section>

          <hr class="my-5" />

          <section>
            <div class="h6 mb-3">Seat Type</div>
            <div class="row">
              <div class="col-md-12 mb-4" v-for="(item , index) in screenType" :key="index">
                <div class="row align-items-center">
                  <div class="col-md-4">
                    <div class="d-flex align-items-center">
                      <div class="input-container w-100">
                        <input
                          type="text"
                          :id="'stn'+index"
                          name="seat type"
                          v-model="item.screenName"
                          placeholder="Seat Type Name"
                          v-validate="{required: 'required', regex:/^[a-zA-Z0-9 ]*$/}"
                        />

                        <label :for="'stn'+index">Seat Type Name</label>
                      </div>

                      <Tooltip :title="`Different types of Seat like Normal Seats, Wheel chair, Couple Seats etc`" />

                    </div>
                    <p v-if="submitted && errors.has('seat type')" class="error_message">
                      <!-- {{ item.fieldname }} -->
                      {{ errors.first("seat type")}}
                    </p>
                  </div>

                  <div class="col-md-2">
                    <!-- <div class="form__field">
                    <div class="form__label">
                      <button @click="$modal.show('my-custom-ui'+index)">Please choose a color</button>
                      <modal :name="'my-custom-ui'+index" :adaptive="true" height="192">
                        <div class="custom-ui-class">
                          <swatches v-model="item.sst_seat_color_code" inline></swatches>
                        </div>
                      </modal>
                    </div>
                    </div>-->
                    <input
                      type="color"
                      :id="'seatcolor'+index"
                      v-model="item.sst_seat_color_code"
                      placeholder="Seat Color"
                    />
                    <label :for="'seatcolor'+index">Seat Color</label>
                  </div>
                  <div class="col-md-4">
                    <div class="input-container">
                      <input
                        type="text"
                        :id="'nseat'+index"
                        v-model="item.noOfSeats"
                        placeholder="No of seats"
                        name="No of seats"
                        v-validate="'required|numeric'"
                      />
                      <label :for="'nseat'+index">No of seats</label>
                    </div>
                    <p v-if="submitted && errors.has('No of seats')" class="error_message">
                      <!-- {{ item.fieldname }} -->
                      {{ errors.first("No of seats")}}
                    </p>
                  </div>
                  <div class="col-md-2">
                    <button
                      v-if="index == 0"
                      class="btn-transparent"
                      v-on:click.prevent.stop="addScreenType()"
                    >
                      <img src="@/assets/img/icons/plus.svg" height="35" width="35" alt />
                    </button>

                    <button
                      v-else
                      class="btn-transparent"
                      v-on:click.prevent.stop="removeScreenType(index)"
                    >
                      <img src="@/assets/img/icons/minus.svg" height="35" width="35" alt />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- NAVIGATIONS -->
          <section>
            <div class="text-center">
              <router-link class="btn-outline-blue-lg w-25" to="cinema-configuration">Back</router-link>
              <!-- <router-link class="btn-blue-lg w-25" to="add-seat-layout">Proceed</router-link> -->
              <router-link class="btn-blue-lg w-25" to v-on:click.native="onSubmit()">Proceed</router-link>
              <router-link class="btn-outline-blue-lg w-25" to="cinema-concession-levels">Skip</router-link>

              <!-- <router-link
                v-if="current_screen_index > 1 && parseInt(noOfScreens) > 1"
                to="add-seat-layout"
                class="btn-blue-lg w-25"
              >Skip</router-link>-->
            </div>
          </section>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";
import SetupService from "@/services/SetupService";
import Swatches from "vue-swatches";

// Import the styles too, globally
import "vue-swatches/dist/vue-swatches.min.css";

export default {
  name: "Add Screens",
  components: {
    Swatches
  },
  data() {
    return {
      submitted: false,
      current_screen_index: "1",
      color: "#000",
      screen_details: {
        screen_name: "",
        no_of_rows: "",
        no_of_cols: "",
        cinema_id: window.localStorage.getItem("CURRENT_CINEMA_ID") || 1
      },
      screenType: [
        {
          screenName: "",
          noOfSeats: "",
          sst_seat_color_code: ""
        }
      ],
      selectedFormat: {
        label: "Select Movie Format",
        value: ""
      },
      Formats: [],
      FormatMethod: {
        GET: "/admin/",
        tableName: "ms_movie_formats",
        urlKey: "movieformats"
      }
    };
  },
  mounted() {
    this.getFormatList();
  },
  computed: {
    noOfCinemas() {
      return this.$store.getters.NO_OF_CINEMAS || 1;
    },
    currentCinemaIndex() {
      return this.$store.getters.currentCinemaIndex;
    },
    noOfScreens() {
      return this.$store.getters.noOfScreens;
    },
    cinemas() {
      return this.$store.getters.CINEMAS;
    }
  },
  methods: {
    onSelectFormat: function(format) {
      this.selectedFormat.label = format.mf_name;
      this.screen_details["screen_format_id"] = format.mf_id;
    },
    addScreenType: function() {
      this.screenType.push({
        screenName: "",
        noOfSeats: "",
        sst_seat_color_code: ""
      });
    },
    removeScreenType: function(index) {
      this.screenType.splice(index, 1);
    },
    ResetForm: function() {
      this.screen_details = {
        screen_name: "",
        no_of_rows: "",
        no_of_cols: ""
      };
      (this.selectedFormat = {
        label: "Select Movie Format",
        value: ""
      }),
        (this.screenType = [
          {
            screenName: "",
            noOfSeats: "",
            sst_seat_color_code: ""
          }
        ]);
    },
    onSubmit: function() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        console.log("valid :", valid);
        if (valid) {
          let payload = {
            screen_details: this.screen_details,
            screenType: this.screenType
          };
          SetupService.AddScreen(payload)
            .then(result => {
              const { data } = result;
              if (data.status) {
                if (
                  this.current_screen_index == this.$store.getters.noOfScreens
                ) {
                  this.$router.push({
                    path: "add-seat-layout"
                  });
                } else {
                  this.current_screen_index++;
                  this.ResetForm();
                }
              }
            })
            .catch(err => {});
        }
      });
    },
    getFormatList: function() {
      this.Formats = [];
      let body = this.getRequestBody("GET", undefined, this.FormatMethod);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Formats = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Installation/addScreens.vue